<template>
  <svg
    width="22px"
    height="22px"
    viewBox="0 0 22 22"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="Desktop"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <g
        id="D_guidelines"
        transform="translate(-636.000000, -370.000000)"
        stroke="currentColor"
        stroke-width="2"
      >
        <g
          id="Group"
          transform="translate(440.000000, 369.000000)"
        >
          <g
            id="icon-contrats"
            transform="translate(197.000000, 2.000000)"
          >
            <path
              id="Path"
              d="M18,0 C19.1045695,0 20,0.8954305 20,2 L20,18 C20,19.1045695 19.1045695,20 18,20 L2,20 C0.8954305,20 0,19.1045695 0,18 L0,2 C0,0.8954305 0.8954305,0 2,0"
            />
            <polygon
              id="Path"
              points="14 10 10 7 6 10 6 0 14 0"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>
<script>
export default {
  name: 'IconContrat'
};
</script>

<style lang="scss" scoped>
  svg{
    stroke: currentColor;
  }
</style>
